import { DocumentGroup } from '../../../../../../interfaces/DocumentGroup';
import getGroupedContractsPeriod from './getGroupedContractsPeriod';
import getDocumentsInSameGroup from './getDocumentsInSameGroup';

export default function getGroupedContractsPeriodIsDisplayable(group: DocumentGroup, documentGroups: DocumentGroup[], forSearch = false): boolean {
  return group.documents.some((d) => (d.visible || forSearch) && (!d.grouped || (d.date.getTime() === getGroupedContractsPeriod(documentGroups, d.contract.systemCode).getTime() || getDocumentsInSameGroup(d, documentGroups.flatMap((x) => x.documents)).length === 0)));
}
